<ng-container [formGroup]="newEditForm">
    <td>{{formatoEtiqueta ? formatoEtiqueta.id : ''}}</td>
    <td class="long" [ngClass]="{'show-error':showError}">
        <input type="text" formControlName="nombre">
    </td>
    <td class="long" [ngClass]="{'show-error':showError}">
        <app-filterable-list  [itemsList]="configuraciones" [selectedItem]="newEditForm.get('configuracion')"
            [disabled]="disabledConfiguracion" [placeHolder]="false">
        </app-filterable-list>
    </td>
    <td>{{formatoEtiqueta ? (formatoEtiqueta.fechaUpd | date:"dd/MM/yyyy HH:mm:ss") : ''}}</td>
    <td class="multi-actions-bigger">
        <ng-container *ngIf="editable">
            <i class="far fa-save" title="{{'titles.guardar' | translate}}" (click)="save()"></i>
            <i class="fas fa-times" title="{{'global.cancelar' | translate}}" (click)="cancel()"></i>
        </ng-container>
        <ng-container *ngIf="!editable">
            <input type="file"
               #file
               [multiple]="false"
               (change)="onFileChange($event)"
               style="display: none" />
            <i class="fa solid fa-upload" title="{{'titles.asociarFormato' | translate}}" app-click-stop-propagation (click)="file.click()"></i>
            <i class="fa solid fa-download" [ngClass]="{'disabled': !formatoEtiqueta.refArchivo}" title="{{'titles.descargarFormato' | translate}}" (click)="download()"></i>
            <i class="fas fa-pencil-alt"title="{{'titles.editar' | translate}}" app-click-stop-propagation (click)="edit(formatoEtiqueta)"></i>
            <i class="far fa-trash-alt" title="{{'titles.eliminar' | translate}}" app-click-stop-propagation  (click)="askDelete(formatoEtiqueta)"></i>
        </ng-container>
    </td>
</ng-container>
<app-toast *ngIf="showError && mensajes" [messages]="mensajes" (closed)="showError=$event"></app-toast>
<div class="modal" *ngIf="deleteModal">
    <div class="modal-content">
        <header>
            <h4>{{'global.eliminar.descripcion' | translate}}</h4>
        </header>
        <content>
            <p>{{'global.eliminar.confirmacion' | translate}}</p>
        </content>
        <footer>
            <button class="secondary" (click)="closeModal()">{{'global.cancelar' | translate}}</button>
            <button (click)="delete()">{{'global.confirmar' | translate}}</button>
        </footer>
    </div>
</div>